import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface MainMenuItemProps {
    show?: boolean;
    icon: any;
    text: any;
    description?: any;
    disabled?: boolean;
    onClick?: CallableFunction;
    className?: string;
    withLoading?: boolean;
}
const MainMenuItem = ({ show=true, icon, text, description, disabled=false, onClick=() => {}, className='', withLoading=false }: MainMenuItemProps) => {

    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);

    const handleClick = () => {
    if (withLoading) {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 5000);
    }
    onClick?.()
  };


    if (!show) return null;

    return (
        <div onClick={handleClick} className={`${className} flex gap-4 items-center p-2 py-5 cursor-pointer ${disabled ? 'pointer-events-none opacity-30' : ''}`} >
            <div >{icon}</div>
            <div className='w-full grid gap-0.5'>
                <span className='text-base font-semibold leading-none'>{loading ? t('layout.loading_main.default_message') : text}</span>
                {description && <span className='text-sm text-gray-400 leading-none'>{description}</span>}
            </div>
        </div>
    )
}

export default MainMenuItem;